// External Imports
import { useEffect, useState } from "react";
import Heading from "../UI/Heading";
import { requestPartnerAPI } from "../../api/server";
import DetailPair from "../UI/DetailPair";

// Internal Imports

/** ========================================================================
 * * Application Component
 * This component renders the application submitted by the partner.
 * ========================================================================== */

export default function Application() {
  const [loading, setLoading] = useState(false);
  const [application, setApplication] = useState({});

  // =======================  FETCH APPLICATION  ====================== */
  const fetchApplication = async () => {
    try {
      setLoading(true);
      const response = await requestPartnerAPI("fetch-application", {});
      setApplication(response);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchApplication();
  }, []);

  return (
    <div className="bg">
      <Heading
        isBackArrow={true}
        title="Application"
        description="Following is the information provided in your FAP Application."
      />
      {application ? (
        <div className="info">
          <DetailPair
            label="Full Name"
            value={application.name}
            loading={loading}
          />
          <DetailPair
            label="Phone Number"
            value={application.phone}
            loading={loading}
          />
          <DetailPair
            label="Date of Birth"
            value={application.dateOfBirth}
            loading={loading}
          />
          <DetailPair
            label="Business Name"
            value={application.businessName}
            loading={loading}
          />
          <DetailPair
            label="Business Type"
            value={application.businessType}
            loading={loading}
          />
          <DetailPair label="EIN" value={application.ein} loading={loading} />
          <DetailPair
            label="Business Address"
            value={application.businessAddress}
            loading={loading}
          />
          <DetailPair
            label="Business Revenue"
            value={application.businessRevenue}
            loading={loading}
          />
          <DetailPair
            label="Time in Business"
            value={application.timeInBusiness}
            loading={loading}
          />
          <DetailPair
            label="Primary Bank"
            value={application.bankName}
            loading={loading}
          />
          <DetailPair
            label="Credit Score"
            value={application.creditScore}
            loading={loading}
          />
          <DetailPair label="SSN" value="*** *** ****" loading={loading} />
          <DetailPair
            label="Current Vehicles Owned"
            value={application.vehiclesOwned}
            loading={loading}
          />
          <DetailPair
            label="Value Vehicles Owned"
            value={application.valueVehiclesOwned}
            loading={loading}
          />
          <DetailPair
            label="Owned Vehicles Loan"
            value={application.ownedVehiclesLoan}
            loading={loading}
          />
          <DetailPair
            label="Current Monthly Vehicle Payments"
            value={application.totalCurrentMonthly}
            loading={loading}
          />
          <DetailPair
            label="Preferred Loan Type"
            value={application.loanType}
            loading={loading}
          />
        </div>
      ) : (
        <div className="grid gap-6 my-4 text-center">
          <p className="font-semibold">Application Not Found!</p>
          <p className="text-stone-400 ">
            There is no application associated with your email
            address. If this is a mistake please contact support.
          </p>
        </div>
      )}
    </div>
  );
}
